import ResponseCardsTreeNodeItem from './ResponseCardsTreeNodeItem';

class ResponseCardsTreeNode {
  items: ResponseCardsTreeNodeItem[];

  constructor(items: ResponseCardsTreeNodeItem[]) {
    this.items = [];
    items.forEach((item) => this.items.push(item));
  }
}

export default ResponseCardsTreeNode;
